export enum HomeType {
  ALL = 'all',
  PERSO = 'perso',
}
